import { useTranslation } from 'react-i18next'
import Spinner from '~/components/Spinner'
import { tourAnchor } from '~/helpers/tour/anchors'
import WebhookDeliveriesCard from '~/pages/backoffice/admin/webhooks/components/WebhookDeliveriesCard'
import WebhookEndpointCard from '~/pages/backoffice/admin/webhooks/components/WebhookEndpointCard'
import WebhookSecretCard from '~/pages/backoffice/admin/webhooks/components/WebhookSecretCard'
import { useWebhookSettings } from '~/pages/backoffice/admin/webhooks/use-webhook-settings'

/**
 * Les webhooks de complétion de l'organisation (#5) : où les envoyer, avec quel
 * secret, et ce qu'il est advenu des derniers. Ouverts à toutes les formules (#350).
 */
function WebhookSettings() {
  const { t } = useTranslation()
  const settings = useWebhookSettings()

  if (settings.loading) {
    return <div className="flex justify-center p-10"><Spinner className="size-6" /></div>
  }

  return (
    <div className="flex w-full flex-col gap-6">
      <p className="max-w-3xl text-sm text-muted-foreground" {...tourAnchor('webhooks.intro')}>{t('webhooks.intro')}</p>
      <WebhookEndpointCard
        url={settings.form.url}
        enabled={settings.form.enabled}
        onChange={settings.setForm}
        onSave={settings.save}
        saving={settings.saving}
      />
      <WebhookSecretCard revealed={settings.revealed} configured={settings.endpoint != null} onRegenerate={settings.regenerate} />
      <WebhookDeliveriesCard
        deliveries={settings.deliveries}
        onRefresh={settings.refreshLog}
        onTest={settings.sendTest}
        canTest={settings.endpoint?.enabled === true && !settings.testing}
      />
    </div>
  )
}

export default WebhookSettings
